import getters from './getters.js'
import { getToken } from '@/utils'
import { theme } from '@/utils/theme'

var state = {
  token: getToken(),
  appid: null,
  isHorizontal: false, //  用于判断是否是横屏
  theme, //  用于存储主题
  themeConfig: {}, //  主题的配置
  isInit: false, //  是否init完毕
  status: {
    avatar: '', //  头像
    bind_phone_status: 0, // 绑定手机状态，1：已绑定；0：未绑定
    certification_status: 0, // 认证状态，1：已实名认证；0：未实名认证
    account_up_status: 0, //  账号升级，1：已升级；0：未升级
    user_name: '', // 用户名
    user_id: null, // 用户ID
    mobile: '', //  手机号
    openid: '',
    sid: '',
    event_info: {
      status: false
    }
  },
  init: {
    ui_type: process.env.VUE_APP_UITYPE, // 样式类型，1：贪玩官方；2：无贪玩信息; 3趣通
    official_website: '', //  官网地址
    wechat_account: '', // 微信公众号账号
    wechat_account_name: '', //  微信公众号名称
    wechat_account_qrcode: '', // 微信公众号二维码链接
    game_info: { // 游戏信息
      name: '', //  游戏名
      download_url: '' //  下载地址
    },
    customer_service_info: { //  客服信息
      telephone: '', //  客服电话
      live_url: '', //  在线客服链接
      qq: ''
    },
    pay_type: 'NORMAL', //  NORMAL 正常 IFRAME iframe调用
    identity: null, //  appid
    float_window_display: 0, //  是否显示浮窗
    pay_nc: 0, // 拉起支付不含公司信息 1: 是 0: 否 不含支付信息时，拉起支付接口do参数在原有参数值后添加固定字符串 _notw
    pay_native: 0, //  是否使用原始支付链接 1: 是 0: 否 使用原始支付链接时，拉起支付接口需添加pay_native参数，值为1
    fast_reg: 0, //  是否优先一键注册  1:优先
    switch: [],
    heartbeat_interval: 0 //  心跳间隔，小于60为关，大于60则按此字段的值定时进行心跳上报
  },
  receivedGiftList: [], //  已领取礼包列表
  unreceivedGiftList: [], // 未领取礼包列表
  giftStatus: false, //  是否获取了礼包信息(用于防止重复请求)
  noticeList: [], //  公告列表
  noticeStatus: false, //  是否获取了公告列表(用于防止重复请求)
  cusContent: { //  客服内容
    live_url: '',
    telephone: ''
  },
  cusStatus: false, //  是否获取了客服内容(用于防止重复请求)
  idfa: 'h5_imei',
  gameData: { //  游戏信息
    dataType: 0
  }
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_APPID: (state, appid) => {
    state.appid = appid
  },
  SET_STATUS: (state, status) => {
    state.status = status
  },
  SET_INIT: (state, init) => {
    state.init = init
  },
  SET_ISHORIZONTAL: (state, isHorizontal) => {
    state.isHorizontal = isHorizontal
  },
  SET_THEMECONFIG: (state, themeConfig) => {
    state.themeConfig = themeConfig
  },
  SET_ISINIT: (state, isInit) => {
    state.isInit = isInit
  },
  SET_RECEIVEDLIST: (state, list) => {
    state.receivedGiftList = list
  },
  SET_UNRECEIVEDLIST: (state, list) => {
    state.unreceivedGiftList = list
  },
  SET_NOTICELIST: (state, list) => {
    state.noticeList = list
  },
  SET_CUSCONTENT: (state, obj) => {
    state.cusContent = obj
  },
  SET_GIFTSTATUS: (state, giftStatus) => {
    state.giftStatus = giftStatus
  },
  SET_NOTICESTATUS: (state, noticeStatus) => {
    state.noticeStatus = noticeStatus
  },
  SET_CUSSTATUS: (state, cusStatus) => {
    state.cusStatus = cusStatus
  },
  SET_IDFA: (state, idfa) => {
    state.idfa = idfa
  },
  SET_GAMEDATA: (state, gameData) => {
    state.gameData = gameData
  }
}

export default {
  state,
  getters,
  mutations
}
